// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"c9944ae9","128":"5995d2bc","280":"0d89dfa6","460":"9ca72a97","476":"72ab3c45","477":"2521f15f","507":"c1f96ac0","535":"1bcd2a34","553":"b68a3ce1","570":"1045efe7","693":"964fee7a"}[chunkId] + ".chunk.js";
};